var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _g, _g2, _path22, _path23, _g3, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _g4, _g5, _g6, _g7, _g8, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgZapierImg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 252,
    height: 208,
    viewBox: "0 0 252 208",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M205.235 37.3212C205.235 35.3992 205.043 33.525 204.672 31.7167L214.049 26.3039L205.271 11.0952L195.924 16.4901C193.098 13.9573 189.745 11.9933 186.056 10.7718V0H168.494V10.7718C166.854 11.3167 165.279 11.9993 163.788 12.8196C163.608 12.9154 163.435 13.0232 163.261 13.125C163.087 13.2268 162.908 13.3226 162.734 13.4304C161.279 14.3106 159.896 15.3285 158.609 16.4781L149.28 11.0892L140.502 26.2979L149.831 31.6868C149.477 33.3753 149.286 35.0818 149.256 36.7823C149.256 36.9859 149.256 37.1955 149.256 37.399C149.256 37.5966 149.256 37.7942 149.256 37.9978C149.292 39.6983 149.483 41.4048 149.831 43.0993L140.502 48.4882L149.28 63.6969L158.609 58.308C161.507 60.8947 164.884 62.8108 168.488 63.9963V74.7861H186.05V63.9604C187.805 63.3736 189.523 62.6072 191.188 61.6432C192.888 60.6612 194.451 59.5235 195.858 58.2601L205.265 63.691L214.043 48.4822L204.636 43.0514C205.019 41.2012 205.229 39.2792 205.229 37.3152L205.235 37.3212ZM188.775 49.6977C188.697 49.7696 188.625 49.8355 188.547 49.9073C188.242 50.1827 187.93 50.4402 187.613 50.6917C187.463 50.8055 187.314 50.9192 187.158 51.033C186.895 51.2246 186.631 51.4042 186.356 51.5779C186.14 51.7156 185.919 51.8473 185.697 51.979C185.475 52.1108 185.248 52.2305 185.02 52.3503C184.733 52.5 184.44 52.6377 184.146 52.7694C183.973 52.8473 183.799 52.9191 183.625 52.991C183.248 53.1407 182.871 53.2844 182.482 53.4101C182.386 53.44 182.284 53.476 182.188 53.5059C180.637 53.9729 178.991 54.2364 177.284 54.2364C167.943 54.2364 160.369 46.662 160.369 37.3212C160.369 35.0339 160.83 32.8544 161.65 30.8665C161.692 30.7707 161.728 30.6809 161.77 30.5851C161.92 30.2378 162.094 29.8965 162.267 29.5552C162.381 29.3396 162.495 29.1301 162.614 28.9205C162.734 28.7109 162.86 28.5073 162.992 28.3038C163.195 27.9864 163.405 27.6691 163.632 27.3637C163.692 27.2799 163.752 27.202 163.812 27.1182C165.123 25.4117 166.782 23.9208 168.764 22.7771C176.853 18.1067 187.194 20.879 191.864 28.9684C192.715 30.4474 193.319 31.9982 193.685 33.5789C193.708 33.6807 193.726 33.7765 193.75 33.8783C193.834 34.2795 193.906 34.6806 193.96 35.0818C193.984 35.2674 194.008 35.459 194.026 35.6447C194.062 35.968 194.086 36.2913 194.098 36.6147C194.11 36.8721 194.116 37.1296 194.116 37.3811C194.116 37.6386 194.116 37.896 194.098 38.1535C194.08 38.4768 194.062 38.7942 194.026 39.1175C194.008 39.3091 193.984 39.4947 193.96 39.6863C193.906 40.0875 193.834 40.4887 193.75 40.8839C193.726 40.9857 193.708 41.0875 193.685 41.1893C193.313 42.77 192.715 44.3208 191.864 45.7998C191.014 47.2787 189.966 48.5721 188.781 49.6798L188.775 49.6977Z",
    fill: "#EBEBF2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M246.951 90.7972C246.951 89.7134 246.843 88.6596 246.634 87.6357L251.921 84.582L246.969 76.0076L241.7 79.0494C240.107 77.6183 238.215 76.5166 236.137 75.828V69.7565H226.24V75.828C225.318 76.1333 224.426 76.5226 223.587 76.9836C223.485 77.0375 223.39 77.0974 223.288 77.1513C223.192 77.2111 223.09 77.265 222.994 77.3249C222.174 77.8219 221.396 78.3967 220.665 79.0434L215.408 76.0076L210.456 84.582L215.713 87.6177C215.516 88.5698 215.408 89.5338 215.39 90.4918C215.39 90.6056 215.39 90.7253 215.39 90.8391C215.39 90.9529 215.39 91.0606 215.39 91.1744C215.408 92.1324 215.516 93.0964 215.713 94.0485L210.456 97.0842L215.408 105.659L220.665 102.623C222.3 104.078 224.204 105.162 226.234 105.826V111.91H236.131V105.808C237.119 105.479 238.089 105.042 239.024 104.503C239.982 103.946 240.862 103.305 241.658 102.599L246.957 105.659L251.909 97.0842L246.61 94.0245C246.825 92.9827 246.945 91.8989 246.945 90.7912L246.951 90.7972ZM237.67 97.7788C237.628 97.8207 237.586 97.8566 237.539 97.8986C237.371 98.0542 237.191 98.198 237.012 98.3417C236.928 98.4075 236.844 98.4734 236.754 98.5333C236.604 98.641 236.455 98.7428 236.305 98.8386C236.185 98.9165 236.06 98.9943 235.934 99.0662C235.808 99.138 235.682 99.2099 235.551 99.2757C235.389 99.3596 235.227 99.4374 235.06 99.5152C234.964 99.5571 234.862 99.5991 234.766 99.641C234.557 99.7248 234.341 99.8086 234.12 99.8745C234.066 99.8925 234.012 99.9104 233.952 99.9284C233.078 100.192 232.15 100.342 231.186 100.342C225.922 100.342 221.653 96.0723 221.653 90.8092C221.653 89.5218 221.911 88.2943 222.378 87.1686C222.402 87.1148 222.42 87.0609 222.444 87.013C222.527 86.8154 222.623 86.6238 222.725 86.4322C222.791 86.3124 222.851 86.1926 222.923 86.0729C222.988 85.9531 223.06 85.8394 223.132 85.7256C223.246 85.546 223.366 85.3663 223.491 85.1927C223.527 85.1448 223.557 85.1029 223.593 85.055C224.336 84.091 225.27 83.2527 226.384 82.612C230.946 79.9774 236.772 81.5402 239.407 86.1028C239.886 86.9351 240.227 87.8093 240.437 88.7015C240.449 88.7554 240.461 88.8153 240.473 88.8691C240.52 89.0967 240.556 89.3182 240.592 89.5458C240.604 89.6535 240.616 89.7553 240.628 89.8631C240.646 90.0427 240.658 90.2283 240.67 90.408C240.676 90.5517 240.682 90.6954 240.682 90.8391C240.682 90.9828 240.682 91.1325 240.67 91.2762C240.664 91.4558 240.646 91.6414 240.628 91.8211C240.616 91.9289 240.604 92.0366 240.592 92.1384C240.562 92.3659 240.52 92.5875 240.473 92.815C240.461 92.8749 240.449 92.9288 240.437 92.9887C240.227 93.8808 239.892 94.755 239.413 95.5873C238.934 96.4196 238.341 97.1501 237.676 97.7788H237.67Z",
    fill: "#EBEBF2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M54.4114 149.542C53.8665 148.141 53.1959 146.824 52.4115 145.602L57.7346 138.986L47.0047 130.352L41.6996 136.944C38.9153 135.89 35.9095 135.405 32.8678 135.561L29.814 127.681L16.9705 132.657L20.0242 140.537C18.9763 141.399 18.0243 142.345 17.1621 143.369C17.0603 143.489 16.9645 143.614 16.8627 143.74C16.7609 143.866 16.6591 143.986 16.5633 144.111C15.749 145.165 15.0245 146.303 14.4077 147.512L6.06092 146.213L3.94727 159.823L12.2941 161.122C12.5156 162.458 12.8569 163.763 13.318 165.014C13.3719 165.164 13.4318 165.314 13.4916 165.47C13.5455 165.613 13.5994 165.763 13.6593 165.907C14.1682 167.14 14.791 168.332 15.5274 169.475L10.2283 176.056L20.9583 184.69L26.2574 178.11C29.1075 179.175 32.1193 179.624 35.0952 179.469L38.1489 187.36L50.9925 182.385L47.9268 174.469C49.0405 173.541 50.0823 172.493 51.0284 171.319C51.9924 170.116 52.8127 168.847 53.4893 167.523L61.902 168.829L64.0157 155.219L55.603 153.913C55.3635 152.452 54.9683 150.991 54.4114 149.548V149.542ZM45.879 163.254C45.8431 163.326 45.8071 163.398 45.7712 163.47C45.6275 163.757 45.4718 164.032 45.3102 164.308C45.2323 164.434 45.1545 164.559 45.0706 164.685C44.9329 164.901 44.7892 165.104 44.6395 165.314C44.5198 165.476 44.4 165.637 44.2683 165.793C44.1426 165.949 44.0108 166.104 43.8791 166.254C43.7114 166.446 43.5378 166.631 43.3582 166.811C43.2564 166.919 43.1486 167.02 43.0408 167.122C42.8073 167.338 42.5678 167.553 42.3223 167.751C42.2624 167.805 42.1966 167.853 42.1307 167.901C41.1308 168.685 39.9991 169.338 38.7477 169.823C31.9157 172.469 24.2335 169.074 21.587 162.242C20.9403 160.572 20.6589 158.847 20.6948 157.159C20.6948 157.081 20.6948 157.003 20.7008 156.919C20.7128 156.62 20.7367 156.326 20.7726 156.027C20.7966 155.841 20.8146 155.65 20.8445 155.464C20.8744 155.279 20.9104 155.093 20.9463 154.907C21.0062 154.614 21.072 154.326 21.1499 154.039C21.1678 153.961 21.1918 153.883 21.2157 153.812C21.6888 152.189 22.4791 150.632 23.6048 149.237C28.1974 143.531 36.5442 142.627 42.2505 147.219C43.2923 148.057 44.1725 149.027 44.891 150.075C44.9389 150.141 44.9808 150.207 45.0227 150.279C45.1964 150.548 45.364 150.824 45.5197 151.099C45.5916 151.231 45.6634 151.357 45.7293 151.494C45.8431 151.722 45.9568 151.949 46.0586 152.183C46.1365 152.368 46.2143 152.554 46.2861 152.74C46.358 152.931 46.4298 153.117 46.4957 153.309C46.5736 153.548 46.6514 153.788 46.7173 154.033C46.7592 154.177 46.7951 154.32 46.831 154.464C46.9029 154.776 46.9687 155.087 47.0166 155.398C47.0286 155.476 47.0406 155.56 47.0526 155.638C47.2322 156.895 47.2322 158.2 47.0286 159.524C46.825 160.847 46.4239 162.092 45.873 163.236L45.879 163.254Z",
    fill: "#EBEBF2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M121.348 30.8964H1.61195C0.767686 30.8964 0.0791016 30.2078 0.0791016 29.3635C0.0791016 28.5193 0.767686 27.8307 1.61195 27.8307H121.348C122.192 27.8307 122.88 28.5193 122.88 29.3635C122.88 30.2078 122.192 30.8964 121.348 30.8964Z",
    fill: "#EBEBF2"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M121.348 41.8778H1.61195C0.767686 41.8778 0.0791016 41.1892 0.0791016 40.345C0.0791016 39.5007 0.767686 38.8121 1.61195 38.8121H121.348C122.192 38.8121 122.88 39.5007 122.88 40.345C122.88 41.1892 122.192 41.8778 121.348 41.8778Z",
    fill: "#EBEBF2"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M121.348 52.8591H1.61195C0.767686 52.8591 0.0791016 52.1706 0.0791016 51.3263C0.0791016 50.482 0.767686 49.7935 1.61195 49.7935H121.348C122.192 49.7935 122.88 50.482 122.88 51.3263C122.88 52.1706 122.192 52.8591 121.348 52.8591Z",
    fill: "#EBEBF2"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M121.348 60.7689H1.61195C0.765381 60.7689 0.0791016 61.4552 0.0791016 62.3018C0.0791016 63.1483 0.765381 63.8346 1.61195 63.8346H121.348C122.194 63.8346 122.88 63.1483 122.88 62.3018C122.88 61.4552 122.194 60.7689 121.348 60.7689Z",
    fill: "#EBEBF2"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M121.348 74.8161H1.61195C0.767686 74.8161 0.0791016 74.1275 0.0791016 73.2832C0.0791016 72.4389 0.767686 71.7504 1.61195 71.7504H121.348C122.192 71.7504 122.88 72.4389 122.88 73.2832C122.88 74.1275 122.192 74.8161 121.348 74.8161Z",
    fill: "#EBEBF2"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M121.348 85.7974H1.61195C0.767686 85.7974 0.0791016 85.1088 0.0791016 84.2645C0.0791016 83.4203 0.767686 82.7317 1.61195 82.7317H121.348C122.192 82.7317 122.88 83.4203 122.88 84.2645C122.88 85.1088 122.192 85.7974 121.348 85.7974Z",
    fill: "#EBEBF2"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M121.348 96.7729H1.61195C0.767686 96.7729 0.0791016 96.0843 0.0791016 95.24C0.0791016 94.3957 0.767686 93.7072 1.61195 93.7072H121.348C122.192 93.7072 122.88 94.3957 122.88 95.24C122.88 96.0843 122.192 96.7729 121.348 96.7729Z",
    fill: "#EBEBF2"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M121.348 107.754H1.61195C0.767686 107.754 0.0791016 107.066 0.0791016 106.221C0.0791016 105.377 0.767686 104.688 1.61195 104.688H121.348C122.192 104.688 122.88 105.377 122.88 106.221C122.88 107.066 122.192 107.754 121.348 107.754Z",
    fill: "#EBEBF2"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M121.348 118.736H1.61195C0.767686 118.736 0.0791016 118.047 0.0791016 117.203C0.0791016 116.359 0.767686 115.67 1.61195 115.67H121.348C122.192 115.67 122.88 116.359 122.88 117.203C122.88 118.047 122.192 118.736 121.348 118.736Z",
    fill: "#EBEBF2"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M121.737 196.947C172.514 196.947 213.678 193.06 213.678 188.265C213.678 183.47 172.514 179.583 121.737 179.583C70.9592 179.583 29.7959 183.47 29.7959 188.265C29.7959 193.06 70.9592 196.947 121.737 196.947Z",
    fill: "#EBEBF2"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M148.382 188.726H95.0918L104.259 162.308H139.215L148.382 188.726Z",
    fill: "url(#paint0_linear_22025_109841)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M36.3589 81.9235H207.116V166.481C207.116 171.541 203.008 175.643 197.954 175.643H45.52C40.4604 175.643 36.3589 171.535 36.3589 166.481V81.9235Z",
    fill: "url(#paint1_linear_22025_109841)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M45.52 55.6555H197.948C203.008 55.6555 207.11 59.7631 207.11 64.8167V153.961H36.3589V64.8167C36.3589 59.7571 40.4664 55.6555 45.52 55.6555Z",
    fill: "#3D3D89"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M200.547 64.9125H43.2266V144.531H200.547V64.9125Z",
    fill: "url(#paint2_linear_22025_109841)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M121.737 168.649C124.482 168.649 126.707 166.424 126.707 163.679C126.707 160.935 124.482 158.709 121.737 158.709C118.992 158.709 116.767 160.935 116.767 163.679C116.767 166.424 118.992 168.649 121.737 168.649Z",
    fill: "url(#paint3_linear_22025_109841)"
  }), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M162.262 188.726H81.2124C81.2124 186.007 83.4159 183.798 86.1403 183.798H157.34C160.058 183.798 162.268 186.001 162.268 188.726H162.262Z",
    fill: "url(#paint4_linear_22025_109841)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M198.439 208C219.014 208 235.694 205.614 235.694 202.671C235.694 199.728 219.014 197.342 198.439 197.342C177.863 197.342 161.184 199.728 161.184 202.671C161.184 205.614 177.863 208 198.439 208Z",
    fill: "#EBEBF2"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M217.078 118.358H179.799C176.859 118.358 174.476 120.742 174.476 123.681V195.288C174.476 198.228 176.859 200.611 179.799 200.611H217.078C220.018 200.611 222.401 198.228 222.401 195.288V123.681C222.401 120.742 220.018 118.358 217.078 118.358Z",
    fill: "#4B4BA0"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M222.401 124.089H174.476V194.552H222.401V124.089Z",
    fill: "url(#paint5_linear_22025_109841)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_22025_109841)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M210.367 142.231H186.506C183.566 142.231 181.183 144.614 181.183 147.554V171.415C181.183 174.355 183.566 176.738 186.506 176.738H210.367C213.306 176.738 215.69 174.355 215.69 171.415V147.554C215.69 144.614 213.306 142.231 210.367 142.231Z",
    fill: "url(#paint6_linear_22025_109841)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_22025_109841)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M198.438 172.697C191.157 172.697 185.229 166.769 185.229 159.488C185.229 152.207 191.157 146.279 198.438 146.279C205.719 146.279 211.647 152.207 211.647 159.488C211.647 166.769 205.719 172.697 198.438 172.697ZM198.438 148.716C192.499 148.716 187.672 153.548 187.672 159.488C187.672 165.428 192.505 170.254 198.438 170.254C204.372 170.254 209.204 165.422 209.204 159.488C209.204 153.554 204.372 148.716 198.438 148.716Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.48 164.505L192.864 160.44L194.798 158.242L197.211 160.368L201.803 155.111L204.007 157.039L197.48 164.505Z",
    fill: "white"
  }))), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M204.444 126.879H192.433C190.583 126.879 189.08 125.376 189.08 123.526H207.797C207.797 125.376 206.294 126.879 204.444 126.879Z",
    fill: "#4B4BA0"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M202.768 124.089H194.098C193.787 124.089 193.541 123.837 193.541 123.532C193.541 123.22 193.792 122.975 194.098 122.975H202.768C203.073 122.975 203.325 123.226 203.325 123.532C203.325 123.843 203.073 124.089 202.768 124.089Z",
    fill: "white"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_22025_109841)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M163.249 47.3325H69.0208C66.081 47.3325 63.6978 49.7157 63.6978 52.6556V109.628C63.6978 112.568 66.081 114.951 69.0208 114.951H163.249C166.189 114.951 168.572 112.568 168.572 109.628V52.6556C168.572 49.7157 166.189 47.3325 163.249 47.3325Z",
    fill: "url(#paint7_linear_22025_109841)"
  }))), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M163.244 52.6495H69.0156V109.622H163.244V52.6495Z",
    fill: "#3D3D89"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M88.8648 60.2659H79.063V61.5891H88.8648V60.2659Z",
    fill: "#FFC700"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M112.025 60.2659H91.9658V61.5891H112.025V60.2659Z",
    fill: "#FFC700"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M93.026 65.6309H83.2241V66.9541H93.026V65.6309Z",
    fill: "white"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M153.442 65.6309H96.1274V66.9541H153.442V65.6309Z",
    fill: "#1E9AFF"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M93.026 70.6066H83.2241V71.9298H93.026V70.6066Z",
    fill: "white"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M153.442 70.6066H96.1274V71.9298H153.442V70.6066Z",
    fill: "#1E9AFF"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M93.026 75.5884H83.2241V76.9117H93.026V75.5884Z",
    fill: "white"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M153.442 75.5884H96.1274V76.9117H153.442V75.5884Z",
    fill: "#1E9AFF"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M93.026 80.5701H83.2241V81.8933H93.026V80.5701Z",
    fill: "white"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M88.8648 85.8392H79.063V87.1625H88.8648V85.8392Z",
    fill: "#FFC700"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M112.025 85.8392H91.9658V87.1625H112.025V85.8392Z",
    fill: "#FFC700"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M133.005 91.0126H95.8818V97.0003H133.005V91.0126Z",
    fill: "white"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M133.083 96.1799H96.1274V97.5032H133.083V96.1799Z",
    fill: "white"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M93.0262 96.1799H89.7749V97.5032H93.0262V96.1799Z",
    fill: "#1E9AFF"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M93.026 101.162H83.2241V102.485H93.026V101.162Z",
    fill: "#1E9AFF"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M133.083 101.162H96.1274V102.485H133.083V101.162Z",
    fill: "white"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M153.86 91.2042H135.748V92.5275H153.86V91.2042Z",
    fill: "white"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M153.86 96.1799H135.748V97.5032H153.86V96.1799Z",
    fill: "white"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M153.86 101.162H135.748V102.485H153.86V101.162Z",
    fill: "white"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M153.442 80.5701H96.1274V81.8933H153.442V80.5701Z",
    fill: "#1E9AFF"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_d_22025_109841)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.5972 73.9418H16.2337C13.2939 73.9418 10.9106 76.325 10.9106 79.2648V109.628C10.9106 112.568 13.2939 114.951 16.2337 114.951H46.5972C49.5371 114.951 51.9203 112.568 51.9203 109.628V79.2648C51.9203 76.325 49.5371 73.9418 46.5972 73.9418Z",
    fill: "url(#paint8_linear_22025_109841)"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_d_22025_109841)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.8612 94.4196C40.8612 93.773 40.7953 93.1383 40.6696 92.5275L43.837 90.6953L40.8672 85.5579L37.7057 87.3841C36.7476 86.5279 35.616 85.8632 34.3705 85.4501V81.8096H28.4367V85.4501C27.8799 85.6357 27.353 85.8632 26.85 86.1447C26.7901 86.1746 26.7302 86.2105 26.6704 86.2464C26.6105 86.2824 26.5506 86.3123 26.4907 86.3482C25.9997 86.6476 25.5327 86.9889 25.0956 87.3781L21.9401 85.5579L18.9702 90.6953L22.1257 92.5155C22.006 93.0844 21.9401 93.6652 21.9281 94.24C21.9281 94.3118 21.9281 94.3777 21.9281 94.4496C21.9281 94.5154 21.9281 94.5813 21.9281 94.6531C21.9401 95.228 22.006 95.8028 22.1257 96.3776L18.9702 98.1978L21.9401 103.335L25.0956 101.515C26.0776 102.389 27.2152 103.036 28.4367 103.437V107.084H34.3705V103.425C34.9633 103.228 35.5441 102.964 36.107 102.641C36.6818 102.305 37.2087 101.922 37.6877 101.497L40.8672 103.329L43.837 98.1919L40.6576 96.3596C40.7893 95.7309 40.8552 95.0843 40.8552 94.4196H40.8612ZM35.2986 98.605C35.2986 98.605 35.2447 98.6529 35.2208 98.6769C35.119 98.7667 35.0112 98.8565 34.9034 98.9403C34.8555 98.9822 34.8016 99.0182 34.7477 99.0541C34.6579 99.12 34.5681 99.1798 34.4783 99.2397C34.4064 99.2876 34.3286 99.3295 34.2568 99.3774C34.1789 99.4193 34.1071 99.4613 34.0292 99.5032C33.9334 99.5511 33.8316 99.599 33.7358 99.6469C33.676 99.6708 33.6161 99.7008 33.5622 99.7247C33.4364 99.7786 33.3047 99.8265 33.173 99.8684C33.1371 99.8804 33.1071 99.8924 33.0712 99.8983C32.5443 100.06 31.9934 100.144 31.4126 100.144C28.2571 100.144 25.6944 97.5871 25.6944 94.4256C25.6944 93.6532 25.8501 92.9167 26.1255 92.2461C26.1375 92.2162 26.1494 92.1862 26.1674 92.1503C26.2213 92.0305 26.2752 91.9168 26.3351 91.803C26.371 91.7312 26.4129 91.6593 26.4548 91.5875C26.4967 91.5156 26.5386 91.4497 26.5806 91.3779C26.6524 91.2701 26.7183 91.1623 26.7961 91.0605C26.8141 91.0306 26.838 91.0066 26.856 90.9767C27.2991 90.4019 27.8619 89.8989 28.5266 89.5097C31.2629 87.929 34.7537 88.869 36.3345 91.5994C36.6219 92.0964 36.8255 92.6233 36.9512 93.1562C36.9572 93.1921 36.9632 93.2221 36.9752 93.258C37.0051 93.3957 37.0291 93.5275 37.047 93.6652C37.053 93.731 37.065 93.7909 37.071 93.8568C37.0829 93.9646 37.0889 94.0723 37.0949 94.1861C37.0949 94.2699 37.0949 94.3597 37.0949 94.4436C37.0949 94.5334 37.0949 94.6172 37.0949 94.707C37.0949 94.8148 37.0829 94.9226 37.071 95.0304C37.065 95.0962 37.059 95.1561 37.047 95.222C37.0291 95.3597 37.0051 95.4914 36.9752 95.6291C36.9692 95.6651 36.9632 95.695 36.9512 95.7309C36.8255 96.2638 36.6219 96.7907 36.3345 97.2877C36.0471 97.7847 35.6938 98.2278 35.2926 98.599L35.2986 98.605Z",
    fill: "white"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_d_22025_109841)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M232.072 26.1721H185.745C182.806 26.1721 180.422 28.5553 180.422 31.4952V77.8218C180.422 80.7617 182.806 83.1449 185.745 83.1449H232.072C235.012 83.1449 237.395 80.7617 237.395 77.8218V31.4952C237.395 28.5553 235.012 26.1721 232.072 26.1721Z",
    fill: "url(#paint9_linear_22025_109841)"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_d_22025_109841)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M223.024 44.1472C221.851 44.1472 220.737 44.4107 219.743 44.8777C218.378 40.0037 213.911 36.4291 208.6 36.4291C203.289 36.4291 198.966 39.89 197.523 44.6442C196.672 44.3208 195.756 44.1472 194.798 44.1472C190.535 44.1472 187.08 47.6021 187.08 51.8653H230.742C230.742 47.6021 227.287 44.1472 223.024 44.1472Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.876 64.8526L208.905 72.8821L216.935 64.8526H211.528V55.3801H206.289V64.8526H200.876Z",
    fill: "white"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter7_d_22025_109841)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.5972 23.5914H16.2337C13.2939 23.5914 10.9106 25.9746 10.9106 28.9145V59.278C10.9106 62.2178 13.2939 64.601 16.2337 64.601H46.5972C49.5371 64.601 51.9203 62.2178 51.9203 59.278V28.9145C51.9203 25.9746 49.5371 23.5914 46.5972 23.5914Z",
    fill: "url(#paint10_linear_22025_109841)"
  }))), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M47.0759 28.4354H15.7544V59.757H47.0759V28.4354Z",
    fill: "#3D3D89"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9279 34.5369H21.0479V35.8601H23.9279V34.5369Z",
    fill: "white"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M40.1786 34.5369H25.4429V35.8601H40.1786V34.5369Z",
    fill: "#1E9AFF"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5266 38.9797H21.0479V40.303H25.5266V38.9797Z",
    fill: "white"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M41.7713 38.9797H27.0356V40.303H41.7713V38.9797Z",
    fill: "#1E9AFF"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9279 47.3446H21.0479V48.6679H23.9279V47.3446Z",
    fill: "white"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M40.1786 47.3446H25.4429V48.6679H40.1786V47.3446Z",
    fill: "#1E9AFF"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5266 51.7933H21.0479V53.1166H25.5266V51.7933Z",
    fill: "white"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M41.7713 51.7933H27.0356V53.1166H41.7713V51.7933Z",
    fill: "#1E9AFF"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M22.8684 43.4286H18.3896V44.7519H22.8684V43.4286Z",
    fill: "white"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M44.4357 43.4286H24.377V44.7519H44.4357V43.4286Z",
    fill: "#1E9AFF"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M134.862 123.167H122.851V135.178H134.862V123.167Z",
    fill: "#A7C8FF"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M152.316 123.167H140.305V135.178H152.316V123.167Z",
    fill: "#A7C8FF"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M169.764 123.167H157.753V135.178H169.764V123.167Z",
    fill: "#A7C8FF"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M193.685 90.5398H175.572V91.8631H193.685V90.5398Z",
    fill: "#A7C8FF"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M193.685 95.5215H175.572V96.8448H193.685V95.5215Z",
    fill: "#A7C8FF"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M193.685 100.497H175.572V101.821H193.685V100.497Z",
    fill: "#A7C8FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_22025_109841",
    x: 170.523,
    y: 140.461,
    width: 55.8271,
    height: 55.827,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 8.89
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.33
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0666667 0 0 0 0 0.447059 0 0 0 0 0.835294 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_22025_109841"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_22025_109841",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_22025_109841",
    x: 177.729,
    y: 142.529,
    width: 41.4177,
    height: 41.4176,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3.75
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.75
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.117647 0 0 0 0 0.521569 0 0 0 0 1 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_22025_109841"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_22025_109841",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_22025_109841",
    x: 53.0378,
    y: 45.5625,
    width: 126.194,
    height: 88.9389,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 8.89
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.33
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.117647 0 0 0 0 0.521569 0 0 0 0 1 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_22025_109841"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_22025_109841",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_22025_109841",
    x: 0.250645,
    y: 72.1718,
    width: 62.3298,
    height: 62.3296,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 8.89
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.33
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.117647 0 0 0 0 0.521569 0 0 0 0 1 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_22025_109841"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_22025_109841",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_d_22025_109841",
    x: 11.4702,
    y: 78.0596,
    width: 39.8667,
    height: 40.274,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3.75
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.75
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.117647 0 0 0 0 0.521569 0 0 0 0 1 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_22025_109841"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_22025_109841",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_d_22025_109841",
    x: 169.762,
    y: 24.4021,
    width: 78.2927,
    height: 78.2928,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 8.89
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.33
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.117647 0 0 0 0 0.521569 0 0 0 0 1 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_22025_109841"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_22025_109841",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_d_22025_109841",
    x: 179.58,
    y: 32.6791,
    width: 58.6621,
    height: 51.453,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3.75
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.75
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.117647 0 0 0 0 0.521569 0 0 0 0 1 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_22025_109841"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_22025_109841",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter7_d_22025_109841",
    x: 0.250645,
    y: 21.8214,
    width: 62.3298,
    height: 62.3296,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 8.89
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.33
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.117647 0 0 0 0 0.521569 0 0 0 0 1 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_22025_109841"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_22025_109841",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_22025_109841",
    x1: 104.103,
    y1: 162.464,
    x2: 139.371,
    y2: 197.731,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#A7C8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#AACAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#B6D2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#CAE0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D8E9FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_22025_109841",
    x1: 56.9565,
    y1: 61.3258,
    x2: 186.518,
    y2: 190.881,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D8E9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A7C8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_22025_109841",
    x1: 62.6506,
    y1: 45.4825,
    x2: 181.123,
    y2: 163.955,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#562BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7DA5FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_22025_109841",
    x1: 118.222,
    y1: 160.164,
    x2: 125.252,
    y2: 167.194,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A7C8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D8E9FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_22025_109841",
    x1: 100.966,
    y1: 166.937,
    x2: 142.508,
    y2: 208.479,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A7C8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#73ABFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_22025_109841",
    x1: 168.836,
    y1: 129.723,
    x2: 228.036,
    y2: 188.917,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#562BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7DA5FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_22025_109841",
    x1: 182.739,
    y1: 143.788,
    x2: 214.133,
    y2: 175.181,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#35FFFF",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#35E6BB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_22025_109841",
    x1: 74.5654,
    y1: 39.5725,
    x2: 157.698,
    y2: 122.705,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#35C9E2",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#35E6BB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_22025_109841",
    x1: 12.4674,
    y1: 75.4986,
    x2: 50.3575,
    y2: 113.389,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#35C9E2",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#35E6BB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_22025_109841",
    x1: 181.979,
    y1: 27.7289,
    x2: 235.838,
    y2: 81.5881,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#35C9E2",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#35E6BB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_22025_109841",
    x1: 12.4674,
    y1: 25.1542,
    x2: 50.3575,
    y2: 63.0442,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#35C9E2",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#35E6BB"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgZapierImg);
export default __webpack_public_path__ + "static/media/zapierImg.4ebb3e02fc042f8ad2b50820a05e7ea8.svg";
export { ForwardRef as ReactComponent };